import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import checkoutGraph from "../../assets/images/checkout-graph.png";
import weightLossStories from "../../assets/images/weight-loss-stories.png";
import CustomStepper from "./Stepper";

const NewSignupPage9: React.FC = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState<string | null>(null);
  const [state, setState] = useState<string | null>(null);
  const [currentWeight, setCurrentWeight] = useState<string | null>(null);
  const [idealWeight, setIdealWeight] = useState<string | null>(null);
  const [lostWeight, setLostWeight] = useState<number | null>(null);
  const [weights, setWeights] = useState({
    currentWeight: 0,
    idealWeight: 0,
    firstInterval: 0,
    secondInterval: 0,
    thirdInterval: 0,
  });

  const isNewFunnelVariant = localStorage.getItem("isNewFunnelVariant") === "true";

  const nextChargeDate = new Date();
  nextChargeDate.setMonth(nextChargeDate.getMonth() + 1); // Add 1 month
  // Get today's date
  const today = new Date();
  const futureDate = new Date(today);
  futureDate.setDate(today.getDate() + 150);

  const options: Intl.DateTimeFormatOptions = {
    month: "long", // Use 'long' for full month name
    day: "numeric", // Day as a number
  };

  const handleBack = () => {
    if(isNewFunnelVariant){
      navigate("/getting-started/step-7");
    }else{
      navigate("/getting-started/step-8");
    }   
  };

  const location = useLocation();

const safeNavigate = (path: string) => {
  if (location.pathname !== path) {
    navigate(path, { replace: true });
  }
};

  const futureDateValue = futureDate.toLocaleString("en-US", options);

  useEffect(() => {
    const step8Completed = localStorage.getItem("step-8-completed");
    const step7Completed = localStorage.getItem("step-7-completed");
  
    if (isNewFunnelVariant) {
      safeNavigate(step7Completed ? "/getting-started/step-9" : "/getting-started/step-7");
    } else {
      safeNavigate(step8Completed ? "/getting-started/step-9" : "/getting-started/step-8");
    }
  }, []);

  useEffect(() => {
    const storedFirstName = localStorage.getItem("firstName");
    const storedState = localStorage.getItem("fullState");
    const storedCurrentWeight = localStorage.getItem("weight");
    const storedIdealWeight = localStorage.getItem("idealWeight");

    // Safely parse and set state
    setFirstName(storedFirstName ? JSON.parse(storedFirstName).value : null);
    setState(storedState ? JSON.parse(storedState).value : null);
    setCurrentWeight(
      storedCurrentWeight ? JSON.parse(storedCurrentWeight).value : null
    );
    setIdealWeight(
      storedIdealWeight ? JSON.parse(storedIdealWeight).value : null
    );

    // Calculate lost weight if both weights are available
    if (storedCurrentWeight && storedIdealWeight) {
      const current = parseFloat(JSON.parse(storedCurrentWeight).value);
      const ideal = parseFloat(JSON.parse(storedIdealWeight).value);
      setLostWeight(current - ideal);
    }
  }, []);

  useEffect(() => {
    if (currentWeight && idealWeight) {
      const current = parseFloat(currentWeight);
      const ideal = parseFloat(idealWeight);
      setWeights(() => {
        const difference = current - ideal;
        const intervalSize = Math.floor(difference / 4);

        return {
          currentWeight: Math.floor(current),
          idealWeight: Math.floor(ideal),
          firstInterval: Math.floor(current - intervalSize),
          secondInterval: Math.floor(current - 2 * intervalSize),
          thirdInterval: Math.floor(current - 3 * intervalSize),
        };
      });
    }
  }, [currentWeight, idealWeight]);
  const handleNext = () => {
    if(isNewFunnelVariant){
      navigate("/getting-started/step-14")
    }
    localStorage.setItem("step-9-completed", "true");
  };


  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomStepper activeStep={1} onBack={handleBack} />
        <div className="checkout-container checkout-container-box" style={{ marginTop: "40px" }}>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <span className="content-for-client">
              {firstName},{" "}
              <span
                className="content-for-client"
                style={{ fontWeight: "500" }}
              >
                we can help you lose up to
              </span>{" "}
              {lostWeight} pounds by {futureDateValue}!
            </span>
          </div>
          <div
            className="checkout-graph"
            style={{ position: "relative", display: "inline-block" }}
          >
            <img
              src={checkoutGraph}
              alt="Graph"
              className="graph-image"
              style={{ width: "100%", height: "auto" }}
            />

            {/* Example of overlaying text */}
            <div className="graph-first-interval">{weights.firstInterval}</div>
            <div className="graph-second-interval">
              {weights.secondInterval}
            </div>
            <div className="graph-third-interval">{weights.thirdInterval}</div>
            <div className="graph-final-interval">{weights.idealWeight}</div>
          </div>
          <Link to="/getting-started/step-14">
            <button className="next-btn sticky-btn" onClick={handleNext}>
              Continue →
            </button>
          </Link>
          {!isNewFunnelVariant && 
          <div>
          <div className="signup-intro-text signup-intro-text-css" >
            <span className="signup-content-header">1,500,000 users</span>{" "}
            <span className="highlight-black">
              say Claya is the #1 supplier of
            </span>{" "}
            <span className="signup-content-header">weight loss medication</span>{" "}
            <span className="highlight-black">online!</span>
          </div>
          <div className="intro-subtext" style={{ textAlign: "center" }}>
            <span className="subtext-font">
              Claya’s pharmacy network is the #1 rated supplier of weight loss
              medication online.
            </span>
          </div>
          <div className="weight-loss-story" style={{ marginBottom: "40px" }}>
            <img
              src={weightLossStories}
              alt="Story 1"
              className="story-image"
            />
          </div>
          </div>
          }
          
        </div>
      </div>
    </PageWrapper>
  );
};

export default NewSignupPage9;
